/**
 * Service for fetching combined application metadata
 */

import type { MetadataResponse } from '@/types'

import apiClient from './apiClient'

const API_BASE_URL = '/api/meta'

/**
 * Fetches all application metadata (semesters, headings) in a single API call.
 * Use this for app initialization to reduce network requests.
 * @returns A promise that resolves to MetadataResponse with all metadata.
 */
export async function getMetadata(): Promise<MetadataResponse> {
  try {
    const response = await apiClient.get<MetadataResponse>(API_BASE_URL)
    return response.data
  } catch (error) {
    console.error('Error fetching metadata:', error)
    throw error
  }
}
